import { gql } from "@/__generated__/gql";

export const PREDICTIVE_INDEX_STUDENTS = gql(`
  query predictiveIndexStudents(
    $orgId: ID!
    $argument: StudentListArgumentInput!
    $afterCursor: String
    $beforeCursor: String
    $first: Int
    $last: Int
  ) {
    node(id: $orgId) {
      id
      ... on Organization {
        studentList(
          after: $afterCursor
          before: $beforeCursor
          first: $first
          last: $last
          argument: $argument
        ) {
          edges {
            node {
              id
              profilePhoto {
                id
                url(size: 400)
              }
              studentOrganizationStatus(organizationId: $orgId) {
                name
                commitIndex
                previousCommitIndex
                commitScore
                commitIndexChangedToLowOn
                commitIndexChangedToMediumOn
                commitIndexChangedToHighOn
                funnelState
                inCommunity
                rise {
                  applyIndex
                  previousApplyIndex
                  applyScore
                  applyIndexChangedToLowOn
                  applyIndexChangedToMediumLowOn
                  applyIndexChangedToMediumOn
                  applyIndexChangedToMediumHighOn
                  applyIndexChangedToHighOn
                  commitIndex
                  previousCommitIndex
                  commitScore
                  commitIndexChangedToLowOn
                  commitIndexChangedToMediumLowOn
                  commitIndexChangedToMediumOn
                  commitIndexChangedToMediumHighOn
                  commitIndexChangedToHighOn
                  meltIndex
                  previousMeltIndex
                  meltScore
                  meltIndexChangedToLowOn
                  meltIndexChangedToMediumLowOn
                  meltIndexChangedToMediumOn
                  meltIndexChangedToMediumHighOn
                  meltIndexChangedToHighOn
                  yieldIndex
                  previousYieldIndex
                  yieldScore
                  yieldIndexChangedToLowOn
                  yieldIndexChangedToMediumLowOn
                  yieldIndexChangedToMediumOn
                  yieldIndexChangedToMediumHighOn
                  yieldIndexChangedToHighOn
                  retainIndex
                  previousRetainIndex
                  retainScore
                  retainIndexChangedToLowOn
                  retainIndexChangedToMediumLowOn
                  retainIndexChangedToMediumOn
                  retainIndexChangedToMediumHighOn
                  retainIndexChangedToHighOn
                }
              }
            }
          }
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          totalCount
        }
      }
    }
  }  
`);
